import React, { useEffect } from 'react';
import { withWrapper } from '@shared/react';
import {
    HoldingTableProvider,
    useClientDetailsTable,
    getTransactionsTableColumns,
    UserManagement_TABLE_INFO_URL,
} from './lib';
import { Table } from '@features/Table';
import './HoldingTable.scss';
import { Loader } from '@shared/UI';

interface HoldingTableContentProps {
    accountId: number;
}

const HoldingTableContent: React.FC<HoldingTableContentProps> = ({ accountId }) => {
    const { AssignPositionBody, paginationOptions, setAccountId, holdingLoading } = useClientDetailsTable();

    useEffect(() => {
        if (accountId === 0 || accountId) {
            setAccountId(accountId);
        }
    }, [accountId, setAccountId]);

    if (holdingLoading) {
        return <Loader />;
    }

    return (
        <Table
            columns={getTransactionsTableColumns()}
            data={AssignPositionBody}
            tableTitle={undefined}
            infoLink={UserManagement_TABLE_INFO_URL}
            paginationOptions={paginationOptions}
            filters={undefined}
            row={undefined}
            noScroll={true}
            noBorderTable={true}
        />
    );
};

export const HoldingTable = withWrapper(HoldingTableProvider)(HoldingTableContent);
